
const mutations = {
  SET_JOBS_QUERY(state, data) {
    state.jobsQuery = data;
  },
  SET_JOBS(state, data) {
    state.jobs = data;
  },
  SET_CITIES(state, data) {
    state.cities = data;
  },
  SET_HOT_CITIES(state, data) {
    state.hot_cities = data;
  },
  SET_RECRUIT_INFOS(state, data) {
    state.recruitInfos = data;
  },
  SET_IS_SEARCH(state, data) {
    state.isSearch = data;
  },
  SET_INTENTION(state, data) {
    state.intention = data;
  },
  SET_PAGE_TOTAL(state, data) {
    state.pageTotal = data;
  },
  SET_PAGE(state, data) {
    state.jobsQuery.page = data;
  },
  SET_JOBS_QUERY_KEY_VALUE(state, data) {
    state.jobsQuery[data.key] = data.value;
  },
  // 热门城市列表，底部
  SET_HOST_CITY(state, data) {
    state.hostCity = data;
  },
  // 热门行业
  SET_HOST_INDUSTRIES(state, data) {
    state.hostIndustries = data;
  },
  // 选中的城市行业
  SET_CITY_ACTION(state, data) {
    state.cityAction = data;
  },
  SET_INTENTION_ACTION(state, data) {
    state.intentionAction = data;
  },
  SEARCH_VALUE(state, data) {
    state.searchValue = data;
  },
  SET_JOBS_QUERY_PAGE(state, data) {
    state.jobsQuery.page = data;
  },
  SET_INDUSTRIES(state, data) {
    state.industries = data;
  },
  // 求职意向设置
  SET_USER_INTENTIONS(state, data) {
    state.userIntentions = data;
  }
}

export default mutations;
